export const enum ANALYTICS_EVENTS {
  PAGE_LOAD = 'page-load',
  CUSTOM_ERROR = 'login-error',
  CLICK = 'click',
  NAV_CLICK = 'nav-click',
  ERROR = 'error',
  FORM_START = 'form start',
  FORM_END = 'form end',
  RIGHT_ARROW = 'right arrow',
  HERO_CLICK = 'hero click',
  TILE_CLICK = 'tile click',
  BANNER_CLICK = 'banner click',
  HERO = 'hero',
  TILE = 'tile',
  BANNER = 'banner',
  ASSET_ID_BANNER = 'ban',
  LOGIN = 'LOGIN',
  SIGNUP = 'SIGNUP',
  HEADER_SKY_TEAM = 'header:Skyteam click',
  HEADER_DELTA_LOGO = 'header:Delta logo click',
  HEADER_HOTEL_STAY = 'header:my trips:hotelreservation',
  HEADER_CAR_RESERVATION = 'header:my trips:carreservation',
  SEARCH_SUBMIT = 'SEARCH_SUBMIT',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SEARCH_NO_RESULTS = 'SEARCH_NO_RESULTS',
  SEARCH_CLOSE = 'SEARCH_CLOSE',
  SEARCH_BACKDROP_CLOSE = 'SEARCH_BACKDROP_CLOSE',
  SEARCH_FIELD_FOCUS = 'SEARCH_FIELD_FOCUS',
  SEARCH_TERM = 'SEARCH_TERM'
}

export const SHOPPING_BAND = {
  PAGE_SECTION: 'homepage:shopping-band',
  EVENT_DETAIL: 'click',
  EVENT: 'click',
  TYPE: 'link'
};

export const enum ENVIRONMENTS {
  MOBILE = 'mobile',
  DESKTOP = 'desktop'
}
